// src/components/Layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import '../../styles/layout.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="app-footer">
      {/* Row 1: Brand + main STT navigation */}
      <div className="footer-row">
        <div>
          <div className="footer-brand">{t('appName')}</div>
          <div className="footer-tagline">{t('appTagline')}</div>
        </div>
        <div className="footer-links">
          <Link to="/lecture/upload">{t('navUpload') || 'Upload'}</Link>
          <Link to="/lecture/status">{t('navStatus') || 'Status'}</Link>
          <Link to="/lecture/faq">{t('navFaq') || 'FAQ'}</Link>
          <Link to="/lecture/pricing">{t('navPricing') || 'Pricing'}</Link>
        </div>
      </div>

      {/* Row 2: Social + copyright only (legal links removed) */}
      <div className="footer-row">
        <div className="footer-social">
          <span>{t('footerFindUs')}</span>
          <a href="#">{t('footerFacebook')}</a>
          <a href="#">{t('footerKofi')}</a>
        </div>

        <div className="footer-copy">
          <div className="footer-copy-text">
            {t('footerCopyright')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
